module.exports = {
    HOST:
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:4029/api'      // Development server URL
            : 'https://server.subastasboepro.com/api', // Production server URL
    single_pay_link:
        process.env.NODE_ENV !== 'production'
            ? 'https://buy.stripe.com/test_00g16787c6g4gcU8wx'      // Development single pay link
            : 'https://buy.stripe.com/cN29Cdcgj0CD2ti144',     // Production single pay link
    bundle_pay_link:
        process.env.NODE_ENV !== 'production'
            ? 'https://buy.stripe.com/test_00g16787c6g4gcU8wx'      // Development single pay link
            : 'https://buy.stripe.com/6oEeWx3JNbhhaZO9AB',     // Production single pay link^

    single_price: 4.99,
    bundle_price: 35
};